import React from 'react';

const TermsAndConditions = () => {
  const terms = [
    {
      title: 'Introduction',
      content:
        'The document is an electronic record under the Information Technology Act, 2000, generated by a computer system without requiring physical or digital signatures. Published under Rule 3 (1) of the IT (Intermediaries Guidelines) Rules, 2011, detailing terms for access or usage of the domain https://lushio-fitness.web.app/ ("Platform").',
    },
    {
      title: 'Platform Ownership',
      content:
        'The Platform is owned by LUSHIO, incorporated under the Companies Act, 1956, with its registered office at Vijay Nagar, India',
    },
    {
      title: 'Binding Terms',
      content:
        'By using the Platform, users agree to these Terms of Use, forming a binding agreement with the Platform Owner.',
    },
    {
      title: 'Modification of Terms',
      content:
        'These Terms of Use may be modified anytime without notice. Users are responsible for reviewing the Terms periodically.',
    },
    {
      title: 'User Agreement',
      content:
        '"You," "your," or "user" refers to any person agreeing to use the Platform.',
    },
    {
      title: 'Usage of Platform and Services',
      content:
        'Users agree to provide accurate information during registration and are responsible for actions taken through their account. The Platform\'s information and materials are provided "as is" without warranties on accuracy or fitness for specific purposes.',
    },
    {
      title: 'Proprietary Rights',
      content:
        'The Platform\'s contents, including design and graphics, are proprietary and licensed to the Platform Owner. Users cannot claim any intellectual property rights.',
    },
    {
      title: 'Unauthorized Use',
      content:
        'Unauthorized use of the Platform or Services may result in legal action.',
    },
    {
      title: 'Payment Obligations',
      content:
        'Users agree to pay charges associated with the Services.',
    },
    {
      title: 'Compliance with Laws',
      content:
        'Users must not use the Platform or Services for illegal purposes or activities.',
    },
    {
      title: 'Third-party Links',
      content:
        'The Platform may contain links to third-party websites, which are governed by their own terms and policies.',
    },
    {
      title: 'Legally Binding Transactions',
      content:
        'Initiating a transaction on the Platform constitutes a legally binding contract with the Platform Owner.',
    },
    {
      title: 'Indemnification',
      content:
        'Users indemnify the Platform Owner against claims arising from violations of the Terms, policies, or third-party rights.',
    },
    {
      title: 'Force Majeure',
      content:
        'Parties are not liable for failures caused by force majeure events.',
    },
    {
      title: 'Governing Law',
      content:
        'These Terms are governed by Indian laws.',
    },
    {
      title: 'Dispute Resolution',
      content:
        'All disputes are subject to the exclusive jurisdiction of the courts in Palwal, Haryana.',
    },
    {
      title: 'Contact',
      content:
        'Communications regarding these Terms must be directed to the contact information provided on the website.',
    },
  ];

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }} className='privacy-policy-container'>
      <h1>Terms & Conditions</h1>
      {terms.map((term, index) => (
        <div key={index} style={{ marginBottom: '20px' }}>
          <h2>{term.title}</h2>
          <p>{term.content}</p>
        </div>
      ))}
    </div>
  );
};

export default TermsAndConditions;
